import { z } from "zod";

export const RequestPartnerDtoSchema = z.object({
    titleBefore: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    titleAfter: z.string().nullish(),
    birthNumber: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    email: z.string().nullish(),
    permAddressStreet: z.string().nullish(),
    permAddressStreetNumber: z.string().nullish(),
    permAddressCity: z.string().nullish(),
    permAddressPostCode: z.string().nullish(),
    permAddressCountry: z.string().nullish(),
});

export type RequestPartnerDto = z.infer<typeof RequestPartnerDtoSchema>;